<template lang="html">
    <div id="page__extrasizes" class="center-panel">
        <md-content md-theme="white" v-loader-overlay="progress">
            <FreightExtrasizesMenu></FreightExtrasizesMenu>
            <sort-table
                table-id="freightextrasize" v-bind:columns="tableColumns" v-model="extrasizes" v-on:refresh="getExtrasizes" ref="table" link
                v-bind:per-page="perPage" v-bind:total="extrasizes_amount" v-on:create="addExtrasize" tableHeight="calc(100% - 48px)" 
            >
                <template slot="type" slot-scope="scope"> {{getTypeLabel(scope.item.type)}} </template>
                <template slot="markup_type" slot-scope="scope"> {{ (scope.item.markup_type == '2') ?  'Процентная' : 'Числовая' }} </template>
                <template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" danger-light  rounded v-on:click.stop.prevent="onRemove(scope.item.id)"></z-icon-button>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>

<script>
    import FreightExtrasizesMenu from './FreightExtrasizesMenu.vue';
    import SortTable from "@/components/SortTable";
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: { SortTable, FreightExtrasizesMenu, ZIconButton },
        data() {
            return {
                tableColumns: [
                    { label: 'ID',               field: 'id',           sortable: true, default: true,},
                    { label: 'Предмет наценки',  field: 'type',         sortable: true},
                    { label: 'Величина наценки', field: 'markup_value', sortable: true},
                    { label: 'Тип наценки',      field: 'markup_type',  sortable: true},
                    { label: 'От (кг/м<sup>3</sup>)',      field: 'min',          sortable: true},
                    { label: 'До (кг/м<sup>3</sup>)',      field: 'max',          sortable: true},
                    { label: '',                 field: 'actions' },
                ],
                perPage: 50,
            }
        },
        created() {
            this.getExtrasizes();
            this.$store.commit('setTitle', 'Негабарит');
        },
        computed: {
            /**
            * Список цен негабарита
            */
            extrasizes() {
                return this.$store.state.cost.extrasizes.map(extrasize => {
                    extrasize.routerLink = {name: 'Extrasize', params: {setting_id: extrasize.id}, query: this.$route.query};
                    return extrasize;
                });
            },
            /**
            * Количество цен на негабарит
            */
            extrasizes_amount() {
                return this.$store.state.cost.extrasizes_amount
            },
            /**
            * Флаг загрузки текущего компонента
            */
            progress() {
                return this.progressObj['get-extrasizes-list'];
            },
            /**
            * Объект с флагами загрузки
            */
            progressObj() {
                return this.$store.state.progressObj;
            },
        },
        methods: {
            /**
            * Добавление цены
            */
            addExtrasize() {
                this.$router.push({ name: 'Extrasize',  params: {setting_id: 'new'} });
            },
            /**
            * Получение цен негабарита
            */
            getExtrasizes(page, count, orderBy, orderType, filter) {
                if (!filter) filter = {model: [["way_id", "=", "null"]]};
                this.$store.commit('showProgressBar', 'get-extrasizes-list');
                return this.$store.dispatch('cost/getExtrasizes', {
                    page: page, 
                    order_by: orderBy, 
                    order_type: orderType, 
                    count: count, 
                    filter: filter
                }).finally(() => this.$store.commit('hideProgressBar', 'get-extrasizes-list'));
            },
            /**
            * Удаление цены
            */
            removeExtrasize(id) {
                if (!id) return;
                this.$store.commit('showProgressBar', 'get-extrasizes-list');
                this.$store.dispatch('cost/removeExtrasize', id)
                    .then(() => this.$root.$emit('refresh-table', 'freightextrasize'))
                    .finally(() => this.$store.commit('hideProgressBar', 'get-extrasizes-list'));
            },
            /**
            * Модальное окно с удалением цены
            */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении цены?', 'Действие необратимо!',
                    () => this.removeExtrasize(id)
                );
            },
            /**
            * Присвоение предмета оценки
            */
            getTypeLabel(value) {
                switch (value) {
                    case 'weight': return 'По весу'; break;
                    case 'volume': return 'По объёму'; break;
                    case 'dimensions': return 'По габариту'; break;
                    case 'dimensionssum': return 'По сумме габаритов'; break;
                }
            }
        },
        watch: {
            '$route'() {
                this.getExtrasizes();
                this.$store.commit('setTitle', 'Негабарит');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// FreightExtrasizes.vue?bc2d6fc8